var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDebitIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 47.9956,
    height: 47.9956,
    rx: 23.9978,
    fill: "#F9F9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9979 31.3301L23.9979 16.6634M23.9979 16.6634L31.3312 23.0801M23.9979 16.6634L16.6646 23.0801",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebitIcon);
export default __webpack_public_path__ + "static/media/debit-icon.e09667d8c3539f03df4c600a3974fb12.svg";
export { ForwardRef as ReactComponent };